import { ComponentType } from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faBicycle,
  faCar,
  faChair,
  faDumbbell,
  faFlask,
  faHammerBrush,
  faHouseBuilding,
  faLaptop,
  faMobileScreenButton,
  faPaw,
  faPrint,
  faTabletScreenButton,
  faUtensils,
} from '@awesome.me/kit-cf858715fd/icons/classic/solid';
import { IconType } from 'generated/graphql';
import { LockerIcon } from '../components/icons/LockerIcon';

// Icons are either FontAwesome definitions or bespoke SVG components (lockers),
// matching the office app's ResourceIconConfig shape.
export type CustomResourceIconConfig = {
  fontAwesome?: IconDefinition;
  customComponent?: ComponentType<React.SVGProps<SVGSVGElement>>;
};

// Mirrors the layout-tool template builder's icon table (see
// apps/layout-tool/src/custom-resource-template-builder/constants/icons.ts):
// one explicit entry per backend icon, carrying both of its wire formats —
// the IconType enum and the kebab-cased atlas name the search service serves
// on hits and filter options.
export const icons: {
  gqlName: IconType;
  atlasName: string;
  config: CustomResourceIconConfig;
}[] = [
  {
    gqlName: IconType.FaCarSolid,
    atlasName: 'fa-car-solid',
    config: { fontAwesome: faCar },
  },
  {
    gqlName: IconType.FaBicycleSolid,
    atlasName: 'fa-bicycle-solid',
    config: { fontAwesome: faBicycle },
  },
  {
    gqlName: IconType.FaChairSolid,
    atlasName: 'fa-chair-solid',
    config: { fontAwesome: faChair },
  },
  {
    gqlName: IconType.FaHouseBuildingSolid,
    atlasName: 'fa-house-building-solid',
    config: { fontAwesome: faHouseBuilding },
  },
  {
    gqlName: IconType.FaFlaskSolid,
    atlasName: 'fa-flask-solid',
    config: { fontAwesome: faFlask },
  },
  {
    gqlName: IconType.FaDumbbellSolid,
    atlasName: 'fa-dumbbell-solid',
    config: { fontAwesome: faDumbbell },
  },
  {
    gqlName: IconType.FaLaptopSolid,
    atlasName: 'fa-laptop-solid',
    config: { fontAwesome: faLaptop },
  },
  {
    gqlName: IconType.FaTabletScreenButtonSolid,
    atlasName: 'fa-tablet-screen-button-solid',
    config: { fontAwesome: faTabletScreenButton },
  },
  {
    gqlName: IconType.FaMobileScreenButtonSolid,
    atlasName: 'fa-mobile-screen-button-solid',
    config: { fontAwesome: faMobileScreenButton },
  },
  {
    gqlName: IconType.FaPrintSolid,
    atlasName: 'fa-print-solid',
    config: { fontAwesome: faPrint },
  },
  {
    gqlName: IconType.FaHammerBrushSolid,
    atlasName: 'fa-hammer-brush-solid',
    config: { fontAwesome: faHammerBrush },
  },
  {
    gqlName: IconType.FaUtensilsSolid,
    atlasName: 'fa-utensils-solid',
    config: { fontAwesome: faUtensils },
  },
  {
    gqlName: IconType.FaPawSolid,
    atlasName: 'fa-paw-solid',
    config: { fontAwesome: faPaw },
  },
  {
    gqlName: IconType.CrcLockers,
    atlasName: 'crc-lockers',
    config: { customComponent: LockerIcon },
  },
];

export const iconsByAtlasName = new Map(
  icons.map((icon) => [icon.atlasName, icon.config])
);
